import { IconClipboardList, IconFolders, IconMail, IconShieldCheck, IconStack2, IconUsers } from '@tabler/icons-react'
import type { ReactNode } from 'react'

import { tr } from '@/i18n/tr'
import type { SystemPermission } from '../../../../packages/shared/src/permissions'

/**
 * Yönetim ekranları ve onları açan sistem izni. Kenar menüsü, komut paleti ve rota
 * koruması aynı listeyi kullanır: bir ekranın görünürlüğü tek yerden değişir.
 */
export interface AdminPage {
  path: string
  label: string
  permission: SystemPermission
  icon: ReactNode
}

export const ADMIN_PAGES: AdminPage[] = [
  { path: '/yonetim/kullanicilar', label: tr.nav.users, permission: 'admin.users', icon: <IconUsers size={18} stroke={1.8} /> },
  { path: '/yonetim/ekipler', label: tr.nav.teams, permission: 'admin.teams', icon: <IconStack2 size={18} stroke={1.8} /> },
  { path: '/yonetim/projeler', label: tr.nav.allProjects, permission: 'admin.projects.members', icon: <IconFolders size={18} stroke={1.8} /> },
  { path: '/yonetim/roller', label: tr.nav.roles, permission: 'admin.roles', icon: <IconShieldCheck size={18} stroke={1.8} /> },
  { path: '/yonetim/e-posta', label: tr.nav.mail, permission: 'admin.mail', icon: <IconMail size={18} stroke={1.8} /> },
  { path: '/yonetim/denetim', label: tr.nav.audit, permission: 'admin.audit', icon: <IconClipboardList size={18} stroke={1.8} /> },
]
